import store from 'redux/store';
import API from 'services/api';
import history from 'shared/services/history';
import sessionService from 'services/session';
import showErrorAlert, { parseError } from 'services/errorHandler';
import { sendGetPageFailMessage } from 'services/iframeService';
import { displaySpinner, hideSpinner } from 'redux/actions/global';
import * as CONSTS from 'redux/constants';
import {
  APP_ROUTE_NOT_FOUND,
  CARD_ISSUING_ACTIVATE_SET_KBA,
  CARD_ISSUING_ACTIVATE_THANK_YOU,
  CARD_ISSUING_ERROR
} from 'routes/paths';
import { getRouteWithToken, redirectToError } from 'utilities';
import { HOSTED_PAGE_TYPES, STATUSES } from 'consts';

const getActivateIssuedCardPageStart = () => ({
  type: CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_START
});

const getActivateIssuedCardPageSuccess = data => ({
  type: CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_SUCCESS,
  payload: { data }
});

const getActivateIssuedCardPageFail = (error, data) => ({
  type: CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_FAIL,
  payload: { error, data }
});

const activateCardStart = () => ({
  type: CONSTS.ACTIVATE_ISSUE_CARD_START
});

const activateCardSuccess = data => ({
  type: CONSTS.ACTIVATE_ISSUE_CARD_SUCCESS,
  payload: { data }
});

const activateCardFail = error => ({
  type: CONSTS.ACTIVATE_ISSUE_CARD_FAIL,
  payload: { error }
});

export const getActivateIssuedCardPage = token => async dispatch => {
  const handleGetPageError = (error, url = '') => {
    const { status, data } = parseError(error);
    dispatch(getActivateIssuedCardPageFail(status, data));
    redirectToError({ error, url });
  };

  if (!token) {
    sendGetPageFailMessage(HOSTED_PAGE_TYPES.cardIssuingActivate)();
    return redirectToError({ url: APP_ROUTE_NOT_FOUND });
  }

  try {
    dispatch(displaySpinner());
    dispatch(getActivateIssuedCardPageStart());

    let response;
    try {
      response = await API.makeApiCall({
        method: 'get',
        url: `hosted/issuing/activate_card/${token}`,
        pageToken: token
      });
    } catch (error) {
      const isRedirected = sessionService.handleUnauthorizedError(error, token);
      if (!isRedirected) {
        handleGetPageError(error, APP_ROUTE_NOT_FOUND);
      }
      return;
    }

    const { data: pageData } = response.data || {};
    dispatch(getActivateIssuedCardPageSuccess(pageData));

    const { status } = pageData || {};
    if (status === STATUSES.done) {
      history.push(getRouteWithToken(CARD_ISSUING_ACTIVATE_THANK_YOU, token));
    }
  } catch (error) {
    handleGetPageError(error, CARD_ISSUING_ERROR);
  } finally {
    dispatch(hideSpinner({ meta: { pageType: HOSTED_PAGE_TYPES.cardIssuingActivate } }));
  }
};

export const activateIssuedCard =
  ({ token, formData }) =>
  async dispatch => {
    try {
      dispatch(activateCardStart());
      const response = await API.makeApiCall({
        method: 'post',
        url: `hosted/issuing/activate_card/${token}/activate`,
        data: formData,
        pageToken: token
      });

      const { data: { updated_page, card_issuing, is_valitor: isValitor } = {} } =
        response.data || {};
      const { 'CLCT-712': showKbaPage } =
        store?.getState()?.global?.configData?.feature_flag || {};
      dispatch(
        activateCardSuccess({
          updated_page,
          card_issuing,
          activated: true,
          is_valitor: isValitor
        })
      );
      const route =
        showKbaPage && isValitor
          ? CARD_ISSUING_ACTIVATE_SET_KBA
          : CARD_ISSUING_ACTIVATE_THANK_YOU;
      history.push(getRouteWithToken(route, token));
    } catch (error) {
      const { status } = parseError(error);
      dispatch(activateCardFail(status));
      const isRedirected = sessionService.handleUnauthorizedError(error, token);
      if (!isRedirected) {
        showErrorAlert({ error });
      }
    }
  };
